import React from "react";
import {
  Box,
  CircularProgress,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

const normalizeId = (value) => {
  return value === null || value === undefined ? "" : String(value);
};

export default function ProductCatalogSelectors({
  form,
  sections,
  categories,
  brands,
  onChange,
  loading,
}) {
  return (
    <Paper
      sx={{
        width: "100%",
        borderRadius: "18px",
        border: "1px solid rgba(148,163,184,0.2)",
        boxShadow: "0 16px 36px rgba(15,23,42,0.05)",
        p: { xs: 2, md: 2.4 },
        bgcolor: "#ffffff",
      }}
    >
      <Stack spacing={2}>
        <Box>
          <Typography
            sx={{
              color: "#0f172a",
              fontSize: { xs: 16, md: 17.5 },
              fontWeight: 800,
            }}
          >
            Catálogo base
          </Typography>

          <Typography
            sx={{
              color: "#64748b",
              fontSize: 13,
              mt: 0.4,
            }}
          >
            Selecciona sección, categoría y marca del producto.
          </Typography>
        </Box>

        {loading ? (
          <Stack direction="row" alignItems="center" spacing={1}>
            <CircularProgress size={20} />
          </Stack>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
              gap: 2,
            }}
          >
            <TextField
              select
              label="Sección"
              value={normalizeId(form.section_uuid)}
              onChange={(event) => onChange("section_uuid", normalizeId(event.target.value))}
              fullWidth
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 40,
                  borderRadius: "10px",
                  bgcolor: "#f8fafc",
                },
                "& .MuiInputLabel-root": {
                  fontWeight: 500,
                  color: "#64748b",
                },
              }}
            >
              {sections.map((item) => (
                <MenuItem key={normalizeId(item.uuid)} value={normalizeId(item.uuid)}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Categoría"
              value={normalizeId(form.category_uuid)}
              onChange={(event) => onChange("category_uuid", normalizeId(event.target.value))}
              fullWidth
              size="small"
              disabled={!form.section_uuid}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 40,
                  borderRadius: "10px",
                  bgcolor: "#f8fafc",
                },
                "& .MuiInputLabel-root": {
                  fontWeight: 500,
                  color: "#64748b",
                },
              }}
            >
              {categories.map((item) => (
                <MenuItem key={normalizeId(item.uuid)} value={normalizeId(item.uuid)}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Marca"
              value={normalizeId(form.brand_uuid)}
              onChange={(event) => onChange("brand_uuid", normalizeId(event.target.value))}
              fullWidth
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 40,
                  borderRadius: "10px",
                  bgcolor: "#f8fafc",
                },
                "& .MuiInputLabel-root": {
                  fontWeight: 500,
                  color: "#64748b",
                },
              }}
            >
              {brands.map((item) => (
                <MenuItem key={normalizeId(item.uuid)} value={normalizeId(item.uuid)}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        )}
      </Stack>
    </Paper>
  );
}